import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class IndexService extends BaseService {
    getMybets(payload: any) {
        return this.post(`${VUE_APP_API_URL}/api/purchases`, payload).then(({ data }) => data)
    }
}
export default new IndexService()